import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    templateUrl: './footer.component.html'
})
export class FooterComponent {
    get currentYear(): number {
        return new Date().getFullYear();
    }
}
